export default {
  cardHeaderFontSize: '2rem',
  cardDataFontSize: '1.2rem',
};
